// extracted by mini-css-extract-plugin
export default {"card":"productCardTemp_card__NfFDC"};